export enum CivilStatusID {
  celibe = '1',
  coniugato = '2',
  vedovo = '3',
  divorziato = '4',
  unitoCivilmente = '6',
  scioglimentoUnitoCivilmenteASeguitoDelDecesso = '7',
  scioglimentoUnitoCivilmente = '8',
  nonClassificabile = '9',
}
